"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var teamsnap_ui_1 = require("@teamsnap/teamsnap-ui");
var react_apollo_1 = require("react-apollo");
var _ = require("lodash");
var show_staff_1 = require("../../core/gql/queries/show-staff");
var SetFeedbackMessage = require("../../core/gql/mutations/set-feedback-message");
var utils_1 = require("../../core/utils");
var DeleteStaff = require("../../core/gql/mutations/delete-staff");
var role_1 = require("../../models/role");
var StaffList = function (_a) {
    var organizationId = _a.organizationId, className = _a.className;
    var queryStaff = react_apollo_1.useQuery(show_staff_1.QUERY, { variables: { organizationId: organizationId }, errorPolicy: "all" });
    var staff = _.get(queryStaff.data, "showOrganization.staff", []);
    var setFeedbackMessage = react_apollo_1.useMutation(SetFeedbackMessage.MUTATION)[0];
    var deleteStaff = react_apollo_1.useMutation(DeleteStaff.MUTATION)[0];
    var renderTable = function (staff, loading, organizationId) {
        var sortByKeys = function (element1, element2) {
            var rest = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                rest[_i - 2] = arguments[_i];
            }
            var aString = element1.key.toLowerCase();
            var bString = element2.key.toLowerCase();
            if (aString === bString) {
                return 0;
            }
            else {
                return aString < bString ? -1 : 1;
            }
        };
        return (React.createElement(teamsnap_ui_1.Table, { isLoading: loading, columns: [
                {
                    name: "col1",
                    label: "Name",
                    isSortable: true,
                    sortFn: sortByKeys,
                    align: "left",
                    mods: "u-size4of12",
                },
                {
                    name: "col2",
                    label: "Contact",
                    isSortable: true,
                    sortFn: sortByKeys,
                    align: "left",
                    mods: "u-size4of12",
                },
                {
                    name: "col3",
                    label: "Invitation",
                    isSortable: true,
                    sortFn: sortByKeys,
                    align: "left",
                    mods: "u-size4of12",
                },
                {
                    name: "col4",
                    label: "Actions",
                    isSortable: false,
                    align: "center",
                    mods: "u-size4of12",
                },
            ], rows: createTableRowData(staff, organizationId) }));
    };
    var createTableRowData = function (staffList, _organizationId) {
        return staffList.map(function (staff, pidx) {
            var role = utils_1.capitalize((staff.roles[0] || { type: null }).type.toLowerCase());
            var invitationStatus = utils_1.capitalize(staff.invitationStatus.toLowerCase());
            var renderActionColumn = function () {
                var baseActions = [
                // { text: "Edit", callback: () => {} }, { text: "Resend Invite", callback: () => {} }
                ];
                var deleteInviteCallback = function () { return __awaiter(void 0, void 0, void 0, function () {
                    var data, e_1;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                data = { organizationId: organizationId, staffId: staff.id };
                                _a.label = 1;
                            case 1:
                                _a.trys.push([1, 4, , 6]);
                                return [4 /*yield*/, deleteStaff({
                                        variables: data,
                                        refetchQueries: function () { return [{ query: show_staff_1.QUERY, variables: { organizationId: organizationId } }]; },
                                    })];
                            case 2:
                                _a.sent();
                                // something went right!
                                return [4 /*yield*/, setFeedbackMessage({
                                        variables: {
                                            message: "Successfully removed " + staff.firstName + " " + staff.lastName + " as an admin.",
                                            isError: false,
                                            autoclose: true,
                                        },
                                    })];
                            case 3:
                                // something went right!
                                _a.sent();
                                return [3 /*break*/, 6];
                            case 4:
                                e_1 = _a.sent();
                                // something went wrong!
                                return [4 /*yield*/, setFeedbackMessage({
                                        variables: {
                                            message: "We couldn't remove " + staff.firstName + " " + staff.lastName + " as an admin. Check to make sure they are not a league owner in one of your program seasons. You can contact TeamSnap support to change the owner of any program.",
                                            isError: false,
                                            autoclose: true,
                                        },
                                    })];
                            case 5:
                                // something went wrong!
                                _a.sent();
                                return [3 /*break*/, 6];
                            case 6: return [2 /*return*/];
                        }
                    });
                }); };
                var actionsForNonOwner = [
                    // { text: "Make Owner", callback: () => {} },
                    {
                        text: "Delete",
                        callback: deleteInviteCallback,
                        requiresConfirmation: true,
                        confirmationText: "This user will no longer have access to organization administration and program season commissioner functions in TeamSnap. It will not remove them as a coach, player or member of your organization.",
                    },
                ];
                var actions = baseActions;
                if (!staff.roles.find(function (e) { return e.type == role_1.RoleType.OWNER; })) {
                    actions = __spreadArray(__spreadArray([], actions), actionsForNonOwner);
                }
                if (actions.length > 0) {
                    return React.createElement(teamsnap_ui_1.PopupAction, { direction: ["down"], text: "...", actions: actions, popupStyle: { width: "150px" } });
                }
                return React.createElement(React.Fragment, null);
            };
            return {
                id: parseInt(pidx + "" + staff.id),
                col1: (React.createElement("div", { key: staff.firstName + " " + staff.lastName },
                    React.createElement("div", null,
                        staff.firstName,
                        " ",
                        staff.lastName),
                    React.createElement("div", null,
                        React.createElement("small", null, !!role ? role : "")))),
                col2: (React.createElement("div", { key: staff.emailAddress },
                    React.createElement("div", null, staff.emailAddress),
                    React.createElement("div", null, staff.phoneNumber))),
                col3: React.createElement("div", { key: staff.invitationStatus.toString() }, invitationStatus),
                col4: renderActionColumn(),
            };
        });
    };
    return (React.createElement("div", { className: "container staff-list " + className },
        React.createElement("div", { className: "page-content-body" }, renderTable(staff, queryStaff.loading, organizationId))));
};
exports.default = StaffList;
//# sourceMappingURL=staff-list.js.map